export default class Notification {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all(page) {
        return this.rest.one('notifications').get({ page: page })
    };

    findLatest() {
        return this.rest.one('notifications').one('latest').get();
    };

    find(id) {
        return this.rest.one('notifications', id).get()
    };

    delete(id) {
        return this.rest.one('notifications', id).remove()
    };

    getInProgress() {
        return this.rest.one('notifications/getInProgress').get()
    };
}

Notification.$inject = ['Rest'];
